<template>
  <el-collapse v-model="activePanel">
    <el-collapse-item title="型番/識別メモ" name="1">
      <template v-for="(styleNumber, index) in styleNumbers">
        <div :key="styleNumber.seqNo">
          <el-divider v-if="index > 0"></el-divider>
          <el-row style="margin-bottom: 10px">
            <el-col :span="4" style="padding-top: 7px; padding-right: 10px; text-align: right;">
              <span>型番</span>
            </el-col>
            <el-col :span="18">
              <input-text v-model="styleNumber.number" :limit-length="40" :id="'input-style-number-' + index + '-number'">
              </input-text>
            </el-col>
            <el-col :span="2" style="padding-top: 3px; padding-left: 5px;">
              <el-button type="text"
                        icon="el-icon-delete"
                        @click="removeStyleNumber(index)">
              </el-button>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <el-col :span="4" style="padding-top: 7px; padding-right: 10px; text-align: right;">
              <span>識別メモ</span>
            </el-col>
            <el-col :span="18">
              <input-text v-model="styleNumber.memo" :limit-length="100" :id="'input-style-number-' + index + '-memo'">
              </input-text>
            </el-col>
          </el-row>
        </div>
      </template>
      <el-row style="margin-top: 5px">
        <el-col>
          <el-button type="text" @click="addStyleNumber">型番/識別メモ 追加</el-button>
        </el-col>
      </el-row>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InputText from '@/components/InputText.vue'

export default {
  name: 'StyleNumber',
  components: {
    inputText: InputText
  },
  model: {
    prop: 'styleNumbers',
    event: 'change'
  },
  props: {
    styleNumbers: {
      type: Array
    }
  },
  data: function () {
    return {
      activePanel: ['1']
    }
  },
  methods: {
    addStyleNumber: function () {
      this.styleNumbers.push({
        seqNo: this.styleNumbers.length + 1,
        number: '',
        memo: ''
      })
    },
    removeStyleNumber: function (index) {
      this.styleNumbers.splice(index, 1)
      for (let no = 1; no <= this.styleNumbers.length; no++) {
        this.styleNumbers[no - 1].seqNo = no
      }
    }
  }
}
</script>
